import { useTranslation } from 'react-i18next';
import ErrorBoundary from 'src/components/ErrorBoundary';
import Navbar from 'src/components/NavBar';
import useWindowSize from 'src/hooks/useWindowSize';
import ManageProductFilters from 'src/sections/catalog_products/ManageProductFilters';
import ManageProductsHeader from 'src/sections/catalog_products/ManageProductsHeader';
import ToggleProductView from 'src/sections/catalog_products/ToggleProductView';
import { ViewCatalogProductsContextProvider } from 'src/sections/catalog_products/ViewCatalogProductsContext';

const ViewCatalogProducts = () => {
  const { t } = useTranslation();
  const { height } = useWindowSize();

  return (
    <ErrorBoundary>
      <ViewCatalogProductsContextProvider>
        <div
          style={{
            display: 'grid',
            gridTemplateRows: 'auto minmax(0, 1fr)',
            gridTemplateColumns: '1fr',
            height: `${height}px`,
            overflow: 'hidden',
            gridTemplateAreas: `
          "navbar"
          "main"
        `,
          }}
        >
          <div className="mb-2 min-h-0 bg-white" style={{ gridArea: 'navbar' }}>
            <Navbar title={t('View Catalog Items')} />
            <ManageProductsHeader />
            <ManageProductFilters />
          </div>
          <ToggleProductView />
        </div>
      </ViewCatalogProductsContextProvider>
    </ErrorBoundary>
  );
};

export default ViewCatalogProducts;
